import React, { useEffect } from "react";
import Header from "./Header";
import { myAxios } from "../../api/axios";
import { useLogout } from "../../hooks/useLogout";
import i18next from "i18next";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Sidebar from "./Sidebar";

const Layout = (props) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const isRedeemUser = localStorage.getItem("admin")
    ? JSON.parse(localStorage.getItem("admin")).email === "redeem-admin@gmail.com"
    : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { setLogout } = useLogout();

  myAxios.interceptors.request.use((config) => {
    config.headers["authorization"] = "Bearer " + localStorage.getItem("token");
    config.headers["Accept-Language"] = i18next.language;
    return config;
  });

  myAxios.interceptors.response.use(
    (response) => response,
    (err) => {
      if (err.response?.status === 401) {
        /*setLogout(true);
        document.location.reload();*/
      } else {
        throw err;
      }
    }
  );

  return (
    <div
      id="layout-wrapper"
      style={{ height: "100vh", display: "flex", flexDirection: "column" }}
      lang={'en'}
    >
      <div
        style={{
          position: "fixed",
          width: "100%",
          left: "0px",
          top: "0px",
          zIndex: 999,
        }}
      >
        <Header />
      </div>

      <Container style={{ flex: 1, marginTop: "70px", paddingTop: "25px" }}>
        <Row style={{ height: "100%", alignItems: "flex-start" }}>
          {!isRedeemUser && (
            <Col style={{ position: "sticky", top: "95px" }} md="3">
              <Card style={{ height: "calc(100vh - 120px)" }}>
                <Sidebar isMobile={isMobile} />
              </Card>
            </Col>
          )}
          <Col md={isRedeemUser ? "12" : "9"}>
            <Card>
              <CardBody>{props.children}</CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Layout;
